import type React from "react";
import type { Grade } from "../game/useGameStore";

export const colors = {
  ink: "#14100E",
  wood: "#2A1F17",
  border: "#6B4E32",
  washi: "#ECE3D0",
  tatami: "#7D8B5A",
  amber: "#E0A950",
  steel: "#C8C8CE",
  gold: "#F0C040",
  violet: "#6C5CE7",
  miss: "#4A4038",
} as const;

export const typography = {
  display: {
    fontFamily: "'Times New Roman', 'Yu Mincho', 'Hiragino Mincho ProN', serif",
    fontWeight: 900,
    letterSpacing: "0.08em",
  },
  ui: {
    fontFamily: "'Segoe UI', 'Yu Gothic', system-ui, sans-serif",
    letterSpacing: "0.08em",
  },
  score: {
    fontFamily: "'Segoe UI', system-ui, sans-serif",
    fontWeight: 900,
    fontVariantNumeric: "tabular-nums",
  },
} satisfies Record<string, React.CSSProperties>;

export const labels = {
  ippon: "一本",
  perfect: "技あり",
  great: "素晴",
  good: "良い",
  kataComplete: "型完成",
  dojo: "DOJO",
  training: "TRAINING",
  pass: "合格",
  retry: "RETRY",
  survival: "ENDLESS",
} as const;

export const gradeKanji: Record<Grade, string> = {
  IPPON: labels.ippon,
  PERFECT: labels.perfect,
  GREAT: labels.great,
  GOOD: labels.good,
  LATE: "可",
  MISS: "外れ",
};

export const gradeEnglish: Record<Grade, string> = {
  IPPON: "IPPON",
  PERFECT: "EXCELLENT",
  GREAT: "GREAT",
  GOOD: "GOOD",
  LATE: "LATE",
  MISS: "MISS",
};

export const gradeShort: Record<Grade, string> = {
  IPPON: "IPPON",
  PERFECT: "EXCEL",
  GREAT: "GREAT",
  GOOD: "GOOD",
  LATE: "LATE",
  MISS: "MISS",
};

export const gradeColors: Record<Grade, string> = {
  IPPON: colors.gold,
  PERFECT: colors.amber,
  GREAT: colors.tatami,
  GOOD: colors.steel,
  LATE: colors.border,
  MISS: colors.miss,
};

export const panel = {
  background: colors.wood,
  border: `1px solid ${colors.border}`,
  borderRadius: 8,
  boxShadow: "0 28px 80px rgba(0, 0, 0, 0.45)",
};

export const overlay: React.CSSProperties = {
  position: "fixed",
  inset: 0,
  color: colors.washi,
  background: `radial-gradient(120% 90% at 50% 8%, #2c2015 0%, #1c1510 46%, ${colors.ink} 100%)`,
  ...typography.ui,
};

export const buttonBase: React.CSSProperties = {
  ...typography.ui,
  borderRadius: 6,
  cursor: "pointer",
  textTransform: "uppercase",
  transition: "border-color 160ms ease, color 160ms ease, background 160ms ease",
};

export const primaryButton: React.CSSProperties = {
  ...buttonBase,
  border: `2px solid ${colors.amber}`,
  background: "rgba(224, 169, 80, 0.13)",
  color: colors.amber,
};

export const secondaryButton: React.CSSProperties = {
  ...buttonBase,
  border: `1px solid ${colors.border}`,
  background: "rgba(42, 31, 23, 0.58)",
  color: colors.washi,
};

export const disabledButton: React.CSSProperties = {
  ...secondaryButton,
  opacity: 0.42,
  cursor: "default",
};
